import { getAPI, getAppParserAPI } from './helpers';

export const TEXT_FIELD_STATUS = {
  VALID: 'valid',
  INVALID: 'invalid',
  INITIAL: 'initial',
};
export const publicHash = process.env.PUBLIC_HASH || '';

export const API_DEV = 'https://api.advaice.yourcofounder.com.ua/dev';
export const API_STAGE = 'https://api.advaice.yourcofounder.com.ua/staging';
export const API_PROD = 'https://api.advaice.com';


export const API_URL = getAPI(publicHash);


export const API_ROUTES = {
  LOGIN: '/oauth/token',
  LOGOUT: '/logout',
  REGISTRATION: '/register',
  REGISTRATION_ADMIN: '/register-admin',
  UPDATE_PROFILE: '/profile',
  FACEBOOK_LOGIN: '/oauth/facebook',
  GOOGLE_LOGIN: '/oauth/google',
  LINKEDIN_LOGIN: '/oauth/linkedin',
  GET_PROFILE: '/me',
  GET_PROFILE_STATUS: '/me/status',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  RESET_TOKEN: '/reset-token',
  APP_QUESTIONS: '/apps/questions',
  CREATE_APP: '/apps',
  HIDE_APP: '/apps',
  DELETE_APP: '/apps-delete',
  COUNTRIES: '/countries',
  CAMPAIGN: '/campaign',
  MEDIA: '/media',
  PAYMENT_CARD: '/card',
  PAYMENT_INVOICE: '/invoice',
  PAYMENT_REFILL: '/refill',
  CHART_REPORT: '/reports/chart',
  TABLE_REPORT: 'table-report',
  ADMIN_TABLE_REPORT: 'admin-table-report',
  PASSWORD: '/password',
  BALANCE_HISTORY: '/balance/history',
  EXPORT: '/export',
  USERS: '/users',
  USERS_PRIVILEGES_DEMOTE: '/users/demote-privileges',
  USERS_PRIVILEGES: '/users/elevate-privileges',
  EVENTS: '/events',
  REGIONS: '/regions',
  CITIES: '/cities',
};

export const UNDEFINED = 'undefined';
export const regexps = {
  NO_USER_WITH_EMAIL: /\b(user with email.*not found)\b/,
};
export const AUTH_STATES = {
  INIT: 'INIT',
  AUTH: 'AUTH',
  DEAUTH: 'DEAUTH',
};
export const PROFILE_STEP_STATUSES = {
  INIT: 'INIT',
  NO_PROFILE: 'NO_PROFILE',
  NO_APP: 'NO_APP',
  NO_CAMPAIGN: 'NO_CAMPAIGN',
  NO_PAYMENT_SOURCE: 'NO_PAYMENT_SOURCE',
  OK: 'OK',
};
export const INIT = 'INIT';
export const LOADING = 'LOADING';
export const SUCCESS = 'SUCCESS';
export const ERROR = 'ERROR';

export const ALERT_ERROR = 'ALERT_ERROR';

export const LOCAL_STORAGE_KEYS = {
  CLIENT_TOKEN: 'clientToken',
  USER_TOKEN: 'userToken',
  LAST_URL: 'lastURL',
};
export const CONTEXT_PROVIDERS = {
  AuthFormContext: 'AuthFormContext',
  RegistrationInfoFormContext: 'RegistrationInfoFormContext',
  RestoreFormContext: 'RestoreFormContext',
  ResetFormContext: 'ResetFormContext',
  CreateAppFormContext: 'CreateAppFormContext',
  CreateCampaignFormContext: 'CreateCampaignFormContext',
  InvoiceFormContext: 'InvoiceFormContext',
  UserFormContext: 'UserFormContext',
  PasswordFormContext: 'PasswordFormContext',
  RefillFormContext: 'RefillFormContext',
  CreateAdminModalContext: 'CreateAdminModalContext',
};
export const errorMessages = {
  badCredentials: {
    header: 'Wrong login or password',
    description: 'Please check your credentials.',
  },
};

export const KEYS = {
  ESC: 27,
};

export const DASHBOARD_FILTERS_NAMES = {
  CAMPAIGN: 'campaign-filter',
  PLATFORM: 'platform-filter',
  PARAMETER: 'parameter-filter',
  COMPARE: 'compare-filter',
  USER: 'client-filter',
  APP: 'app-filter',
};


export const USER_ROLES = {
  USER: 'USER',
  ADMIN: 'ADMIN',
};
export const PARAMETERS = {
  INSTALLS: {
    value: 'INSTALLS',
    view: 'Installs',
  },
  CTR: {
    value: 'CTR',
    view: 'CTR',
  },
  CONVERSION: {
    value: 'CONVERSION',
    view: 'Conversion',
  },
  EVENTUNIQUEUSERS: {
    value: 'EVENTUNIQUEUSERS',
    view: 'Unique users',
  },
  CPI: {
    value: 'CPI',
    view: 'CPI',
  },
  SPENT: {
    value: 'SPENT',
    view: 'Spent',
  },
  CPA: {
    value: 'CPA',
    view: 'CPA',
  },
  EVENTS: {
    value: 'EVENTS',
    view: 'Events',
  },
  DAILY_BUDGET: {
    value: 'DAILY_BUDGET',
  },
  PLATFORM_ID: {
    value: 'PLATFORM_ID',
  },
};
export const CPI_VALUES = {
  MIN: 0.10,
};

export const DAILY_BUDGET_VALUES = {
  MIN: 10.00,
};
export const APP_PROJECTIONS = {
  WITH_MEDIA: 'WITH_MEDIA',
  SHORT: 'SHORT',
  FULL: 'FULL',
};
export const MEDIA_AUTHOR = {
  USER: 'USER',
  ADMIN: 'ADMIN',
  COMPETITOR: 'COMPETITOR',
};

export const MEDIA_TYPES = {
  VIDEO: 'VIDEO',
  IMAGE: 'IMAGE',
};

export const mb10 = 10000000;
export const mb100 = 100000000;


export const getImageDev = `${publicHash}/getAppImage/dev/app-data`; // it can change, coz keep it at bottom of file :)
export const getImageProd = '/getAppImageProd/prod/app-data';
export const getImage = getAppParserAPI();

// export const facebookAppId = '505717086526178'; original APP ID
export const facebookAppId = '484546022089689';




// WEBPACK FOOTER //
// ./src/utils/constants.js